import React from "react";
import PropTypes from "prop-types";
import { Field, withFormik } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./batchFilter.data.form";
import { InputText, InputSelect } from "@de-prado-dev/react-component-library";
import { ACTIVE_STATUS } from "../../../../constants/index";

const BatchFilterForm = (props) => {
  const { t } = useTranslation();
  const { handleSubmit, onClean } = props;

  return (
    <div className="row no-margin">
      <div className="col-12 mb-3">
        <div className="accordion" id="batchFilter">
          <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingOne">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseOne"
                aria-expanded="false"
                aria-controls="flush-collapseOne"
              >
                {t("forms.batch.filter")}
              </button>
            </h2>
            <div
              id="flush-collapseOne"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingOne"
              data-bs-parent="#batchFilter"
            >
              <div className="accordion-body">
                <form
                  className="form-horizontal"
                  onSubmit={handleSubmit}
                  autoComplete="off"
                >
                  <div className="row">
                    <div className="col-3">
                      <Field
                        id="code"
                        className="form-control"
                        labelField={t("forms.batch.labels.code")}
                        name="code"
                        placeholder=""
                        component={InputText}
                        fieldType="text"
                      />
                    </div>
                    <div className="col-3">
                      <Field
                        id="active"
                        name="active"
                        labelField={t("forms.variety.labels.active")}
                        component={InputSelect}
                        placeholder=""
                        optionLabel="label"
                        optionValue="code"
                        options={ACTIVE_STATUS.map((item) => ({
                          ...item,
                          label: t(item.label),
                        }))}
                        addOptionEmpty
                        classNamePrefix="dark"
                      />
                    </div>
                  </div>

                  <div className="row mt-3">
                    <div className="col-12 d-flex justify-content-end">
                      <button
                        type="submit"
                        className="btn btn-lg btn-primary me-2"
                      >
                        <i className="fas fa-search"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-lg btn-secondary"
                        onClick={() => onClean(props.resetForm)}
                        title={t("cleanFilter")}
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

BatchFilterForm.propTypes = {
  handleSubmit: PropTypes.func,
  onClean: PropTypes.func,
};

const BatchFilterFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: validationDataModel,
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "BatchFilterForm",
})(BatchFilterForm);

export default BatchFilterFormF;
